import * as firebase from "firebase/app";

export const LOGIN = "login";
export const LOGOUT = "logout";
export const FETCH_ALL_SUPPLIER_IMAGES = "fetch_all_supplier_images";
export const CHECK_AUTH = "check_auth";
export const UPDATE_NAV_TITLE = "update_nav_title";
export const FETCH_USER = "fetch_user";
export const FETCH_IMAGE = "fetch_image";
export const CURRENT_SEARCH_ITEM = "current_search_item";
export const RESET_IMAGES = "reset_image"; //reset imageList state
export const CLEAR_IMAGES = "clear_images"; //clear only the images
export const UPDATE_SNACKBAR = "update_snackbar";
export const CLOSE_SNACKBAR = "close_snackbar";
export const CREATE_SECURITY_QUESTION = "create_security_question";
export const CHECK_SECURITY_ANSWER = "check_security_answer";

export const updateSnackbar = message => {
  return dispatch => {
    dispatch({
      type: UPDATE_SNACKBAR,
      payload: message
    });
  };
};

export const closeSnackbar = () => {
  return dispatch => {
    dispatch({
      type: CLOSE_SNACKBAR,
      payload: ""
    });
  };
};

export const login = (user, password) => {
  return dispatch => {
    firebase
      .auth()
      .signInWithEmailAndPassword(user, password)
      .then(user => {
        dispatch(loginSuccess(user.user));
      })
      .catch(function(error) {
        if (
          error.code === "auth/user-not-found" ||
          error.code === "auth/wrong-password"
        ) {
        } else {
          // context.commit(SET_ERROR, error.message);
        }
        dispatch(updateSnackbar("erorr login"));
      });
  };
};
const loginSuccess = user => ({
  type: LOGIN,
  payload: user
});

export const logout = () => {
  const request = firebase.auth().signOut();
  return {
    type: LOGOUT,
    payload: request
  };
};

export const fetchUser = uid => {
  return dispatch => {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .get()
      .then(doc => {
        if (!doc.exists) {
        } else {
          dispatch({
            type: FETCH_USER,
            payload: doc.data()
          });
        }
      });
  };
};

export const isLoggedIn = () => {
  return dispatch => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        dispatch({
          type: CHECK_AUTH,
          payload: user
        });
      } else {
        dispatch({
          type: CHECK_AUTH,
          payload: { uid: "0" }
        });
      }
    });
  };
};

export const setCurrentSearchItem = item => {
  return dispatch => {
    dispatch({
      type: CURRENT_SEARCH_ITEM,
      payload: item
    });
  };
};

export const resetImages = () => {
  return {
    type: RESET_IMAGES,
    payload: ""
  };
};

export const clearImages = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_IMAGES,
      payload: ""
    });
  };
};

export const fetchImage = imageName => {
  return dispatch => {
    firebase
      .firestore()
      .collection("images")
      .doc(imageName)
      .get()
      .then(doc => {
        if (!doc.exists) {
        } else {
          dispatch({
            type: FETCH_IMAGE,
            payload: doc.data()
          });
        }
      });
  };
};

export const fetchAllSupplierImages = supplierId => {
  return dispatch => {
    firebase
      .firestore()
      .collection("images")
      .where("supplierId", "==", supplierId)
      .get()
      .then(snapshot => {
        if (snapshot.empty) {
          console.log("No matching documents.");
        }
        let imageArr = [];

        snapshot.forEach(doc => {
          imageArr.push(doc.data());
        });
        dispatch({
          type: FETCH_ALL_SUPPLIER_IMAGES,
          payload: imageArr
        });
      });
  };
};

export const updateNavTitle = (title, bool) => {
  return dispatch => {
    if (title) {
      dispatch({
        type: UPDATE_NAV_TITLE,
        payload: { title: title, back: bool }
      });
    }
  };
};

export const checkSecurityAnswer = (id, answer) => {
  return dispatch => {
    firebase
      .firestore()
      .collection("securityAnswer")
      .doc(id)
      .get()
      .then(doc => {
        if (!doc.exists) {
        } else {
          let data = doc.data();

          if (data.answer === answer.toLowerCase()) {
            dispatch({
              type: FETCH_IMAGE,
              payload: doc.data()
            });
          }
        }
      });
  };
};
